import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, type FormInstance } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import type { ProdutoBodyPacoteBarra } from '@/features/produto/types/ProdutoBody';
import { useEmpresaQuery } from '@/features/empresa/hooks/useEmpresaQuery';
import { ProdutoPacoteBarraTipoPreco } from '@/features/produto/types/ProdutoPacoteBarra';
import { useDialog } from '@/std/dialog/useDialog';
import { uuid } from '@/std/util';
import { ProdutoTabEstoquePacoteModal } from './ProdutoTabEstoquePacoteModal';
import { ProdutoTabEstoquePacoteTable } from './ProdutoTabEstoquePacoteTable';

export function ProdutoTabEstoquePacote({
    form,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    setFormDirty: (dirty: boolean) => void;
}) {
    const { empresa } = useEmpresaQuery();

    const dialog = useDialog<ProdutoBodyPacoteBarra>();

    const exibirProdutoCatalogo = Form.useWatch('pro_exibir_catalogo', form) === 1;
    const exibirCheckboxCatalogo =
        empresa?.empresa_slug?.ems_catalogo_ativo === 'S' && exibirProdutoCatalogo;

    const adicionar = (): void => {
        const pro_produto_unidade_idpk = form.getFieldValue('pro_produto_unidade_idpk');

        dialog.actions.add({
            key: uuid(),
            pcb_estoque_idpk: null,
            pcb_exibir_catalogo: exibirProdutoCatalogo ? 'S' : 'N',
            pcb_multiplicador: 1,
            pcb_produto_unidade_idpk: pro_produto_unidade_idpk,
            pcb_tipo_preco: ProdutoPacoteBarraTipoPreco.IgualPrecoCadastro,
        });
    };

    return (
        <div className='flex flex-col gap-2'>
            <Form.Item hidden={true} name='produto_pacote_barra' />

            <div className='flex justify-center'>
                <Button icon={<PlusOutlined />} onClick={adicionar} type='primary'>
                    Adicionar
                </Button>
            </div>

            <ProdutoTabEstoquePacoteTable
                dialog={dialog}
                exibirCheckboxCatalogo={exibirCheckboxCatalogo}
                form={form}
                setFormDirty={setFormDirty}
            />

            <ProdutoTabEstoquePacoteModal dialog={dialog} form={form} setFormDirty={setFormDirty} />
        </div>
    );
}
